import { FC } from "react";
import { useFormContext } from "react-hook-form";

import { useDynamicFormsTranslate } from "@ryde/redux";
import { ICustomField } from "@ryde/shared";

import { Label } from "../../controls";

export const IdLabelTemplate: FC<ICustomField> = ({
  name,
  formLabel,
  e2eData = "id-label-template",
}) => {
  const { getValues } = useFormContext();
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
  });
  const displayValue = getValues(name);
  return (
    <>
      {!!displayValue && (
        <Label
          data-e2e={e2eData}
          data-e2e-template="id-label-template"
          data-e2e-field-name={name}
        >
          {formLabelTranslated} {displayValue}
        </Label>
      )}
    </>
  );
};
